module.exports = __webpack_public_path__ + "img/nemnomi.c1af9635.png";